export function mobileMapHeight() {
  return Math.round(Math.min(360, Math.max(260, window.innerWidth * 0.86)))
}

export function applyBestChinaLayout(seriesItem, mode) {
  seriesItem.roam = false
  seriesItem.zoom = 1
  seriesItem.aspectScale = 0.75
  delete seriesItem.boundingCoords
  delete seriesItem.top
  delete seriesItem.left
  delete seriesItem.right
  delete seriesItem.bottom
  if (mode === 'home-desktop') {
    seriesItem.layoutCenter = ['68%', '54%']
    seriesItem.layoutSize = '90%'
  } else if (mode === 'page-desktop') {
    seriesItem.layoutCenter = ['50%', '52%']
    seriesItem.layoutSize = '108%'
  } else if (mode === 'province-desktop') {
    seriesItem.layoutCenter = ['50%', '52%']
    seriesItem.layoutSize = '86%'
  } else {
    seriesItem.layoutCenter = ['50%', '52%']
    seriesItem.layoutSize = '96%'
  }
}

export function applyMobileChinaLayout(seriesItem) {
  applyBestChinaLayout(seriesItem, 'mobile')
}

export function syncMapContainer(el, mobile) {
  if (!el) return
  if (mobile) {
    el.style.width = '100%'
    el.style.height = mobileMapHeight() + 'px'
  } else {
    el.style.width = '100%'
    el.style.height = ''
  }
}

export function formatMapTooltip(params) {
  const name = (params && params.name) || ''
  const d = params && params.data
  if (!d) return '<div class="gs-map-tip"><b>' + name + '</b><span>暂无统计</span></div>'
  const n = (v) => (v === 0 || v ? v : '-')
  return (
    '<div class="gs-map-tip">' +
    '<b>' + name + '</b>' +
    '<p><span>数据服务商</span><em>' + n(d.dataServiceProvidersNum) + ' 家</em></p>' +
    '<p><span>数据人才</span><em>' + n(d.expertCount) + ' 人</em></p>' +
    '<p><span>政策文件</span><em>' + n(d.fileNum) + ' 份</em></p>' +
    '<p><span>数据交易所</span><em>' + n(d.dataExchange) + ' 个</em></p>' +
    '<p><span>数据产品</span><em>' + n(d.dataProductCount) + ' 个</em></p>' +
    '</div>'
  )
}

export function mapTooltipOption() {
  return {
    show: true,
    trigger: 'item',
    formatter: formatMapTooltip,
    backgroundColor: '#fff',
    borderColor: '#D6E6FF',
    borderWidth: 1,
    padding: 0,
    extraCssText: 'box-shadow: 0 10px 28px rgba(1,101,255,0.14); border-radius: 12px; overflow: hidden;'
  }
}

export function mapPaint(seriesItem) {
  seriesItem.itemStyle = {
    areaColor: '#C9DEFF',
    borderColor: '#fff',
    borderWidth: 1.2,
    shadowColor: 'rgba(1,101,255,0.16)',
    shadowBlur: 14
  }
  seriesItem.emphasis = {
    label: { show: true, color: '#fff' },
    itemStyle: { areaColor: '#0165FF' }
  }
  return seriesItem
}

export function mapVisualRange(list) {
  const nums = (list || []).map((d) => Number(d && (d.value || d.dataServiceProvidersNum)) || 0)
  return Math.max(1, ...nums, 0)
}
